export default {
    data() {
        return {
            rpd_id: 0,
            select_options: {edu_progs: [], years: [], edu_profs: [], curriculum: [], disciplines: [], departments: [], software: [], rpd_samples: []},
            text_info: {purpose: "", task: "", place: "", technology: "", eval_tool: "", literature: "", mto: ""},
            rpd_competitions: { UK: [], OPK_cat: [], OPK: [], PK: [], DPK: []},
            spo_comp: {able: "", know: "", own: "", general:"", business: false, role: false, situation: false, computer: false},
            main_info: {
                discipline: "",
                speciality: "",
                speciality_code: "01.03.02",
                profile: "",
                quality: "",
                year: "",
                edu_form: "",
                course: [],
                period: [],
                credit: [],
                credit_mark: [],
                exam: [],
                load: {hour: 0.0, zet: 0.0},
                creator: {fio: "Фасахов Тимур Ирикович", position: "", title: ""},
                facility: "",
                department: "",
                dep_manager: "",
                grad_dep: "",
                approval_date: "",
                protocol_num: "",
                provisor: "",
                basis: "Рабочая программа составлена на основании Федерального государственного образовательного стандарта ВО для ",
                basis_date: "",
                basis_num: "",
                discipline_type: "Общеобразовательная дисциплина",
                disciplines_index: "",
            },
            themes: [{
                num: 1,
                name: "",
                period: "",
                lecture: "",
                lecture_name: "",
                lecture_pp: "",
                practice: "",
                practice_name: "",
                practice_work: [],
                practice_pp: "",
                lesson_name: "",
                lesson: "",
                lesson_work: [],
                seminar_name: "",
                seminar: "",
                seminar_work: [],
                laboratory: "",
                laboratory_name: "",
                laboratory_pp: "",
                laboratory_work: [],
                ikr: "",
                kto: "",
                ke: "",
                control: "",
                indep_work: "",
                indep_work_name: "",
                control_form: "",
                lec_content_old: "",
                prac_content_old: "",
                lab_content_old: "",
                les_content_old: "",
                sem_content_old: "",
                indep_content_old: "",
                z_themes: false,
            }],
            forms: [],
            spo_controls: [],
            overload: [],
            times: {
                "Лекционные занятия": {input: 0.0, need: 0.0, used: true},
                "Практические занятия": {input: 0.0, need: 0.0, used: true},
                "Лабораторные занятия": {input: 0.0, need: 0.0, used: true},
                "Уроки": {input: 0.0, need: 0.0, used: true},
                "Семинарские занятия": {input: 0.0, need: 0.0, used: true},
                "Иная контактная работа": {input: 0.0, need: 0.0, used: true},
                "Контактные часы на теоретическое обучение": {input: 0.0, need: 0.0, used: true},
                "Экзамен": {input: 0.0, need: 0.0, used: true},
                "Контактные часы на экзамен": {input: 0.0, need: 0.0, used: true},
                "Самостоятельная работа": {input: 0.0, need: 0.0, used: true},
            },
            rpd_sample: false,
            has_z_part: false,
            z_times: {
                "Экзамен": {input: 0.0, period: [], used: false},
                "Зачет": {input: 0.0, period: [], used: false},
                "Зачет с оценкой": {input: 0.0,  period: [], used: false},
            },
            spo_times: {
                "Семестровый контроль": {input: 0.0, period: [], used: false},
                "Другие формы контроля": {input: 0.0, period: [], used: false},
                "Курсовой проект": {input: 0.0, period: [], used: false},
                "Курсовая работа": {input: 0.0,  period: [], used: false},
            }
        }
    },
    computed: {
        o_lectureTime: function (){
            let o_lecturesTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.lecture != ""){
                    o_lecturesTimes += parseFloat(theme.lecture)
                }
            })
            this.times["Лекционные занятия"].input = o_lecturesTimes.toFixed(1)
            return o_lecturesTimes.toFixed(1)
        },
        o_practiceTime: function (){
            let o_practiceTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.practice != ""){
                    o_practiceTimes += parseFloat(theme.practice)
                }
            })
            this.times["Практические занятия"].input = o_practiceTimes.toFixed(1)
            return o_practiceTimes.toFixed(1)
        },
        o_laboratoryTime: function (){
            let o_laboratoryTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.laboratory != ""){
                    o_laboratoryTimes += parseFloat(theme.laboratory)
                }
            })
            this.times["Лабораторные занятия"].input = o_laboratoryTimes.toFixed(1)
            return o_laboratoryTimes.toFixed(1)
        },
        o_lessonTime: function (){
            let o_lessonTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.lesson != ""){
                    o_lessonTimes += parseFloat(theme.lesson)
                }
            })
            this.times["Уроки"].input = o_lessonTimes.toFixed(1)
            return o_lessonTimes.toFixed(1)
        },
        o_seminarTime: function (){
            let o_seminarTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.seminar != ""){
                    o_seminarTimes += parseFloat(theme.seminar)
                }
            })
            this.times["Семинарские занятия"].input = o_seminarTimes.toFixed(1)
            return o_seminarTimes.toFixed(1)
        },
        o_ikrTime: function (){
            let o_ikrTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.ikr != ""){
                    o_ikrTimes += parseFloat(theme.ikr)
                }
            })
            this.times["Иная контактная работа"].input = o_ikrTimes.toFixed(1)
            return o_ikrTimes.toFixed(1)
        },
        o_ktoTime: function (){
            let o_ktoTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.kto != ""){
                    o_ktoTimes += parseFloat(theme.kto)
                }
            })
            this.times["Контактные часы на теоретическое обучение"].input = o_ktoTimes.toFixed(1)
            return o_ktoTimes.toFixed(1)
        },
        o_keTime: function (){
            let o_keTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.ke != ""){
                    o_keTimes += parseFloat(theme.ke)
                }
            })
            this.times["Контактные часы на экзамен"].input = o_keTimes.toFixed(1)
            return o_keTimes.toFixed(1)
        },
        o_controlTime: function (){
            let o_controlTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.control != ""){
                    o_controlTimes += parseFloat(theme.control)
                }
            })
            this.times.Экзамен.input = o_controlTimes.toFixed(1)
            return o_controlTimes.toFixed(1)
        },
        o_indepTime: function (){
            let o_indepTimes = 0.0;
            this.o_themes.forEach(theme => {
                if (theme.indep_work != ""){
                    o_indepTimes += parseFloat(theme.indep_work)
                }
            })
            this.times["Самостоятельная работа"].input = o_indepTimes.toFixed(1)
            return o_indepTimes.toFixed(1)
        },
        o_lectures: function (){
            return this.o_themes.filter(theme => theme.lecture !== "")
        },
        o_practice: function (){
            return this.o_themes.filter(theme => theme.practice !== "")
        },
        o_laboratory: function (){
            return this.o_themes.filter(theme => theme.laboratory !== "")
        },
        o_lesson: function (){
            return this.o_themes.filter(theme => theme.lesson !== "")
        },
        o_seminar: function (){
            return this.o_themes.filter(theme => theme.seminar !== "")
        },
        o_indepWork: function (){
            return this.o_themes.filter(theme => theme.indep_work !== "")
        },
        o_themes: function (){
            return this.themes.filter(theme=> theme.z_themes === false)
        },
        z_themes: function (){
            return this.themes.filter(theme=> theme.z_themes === true)
        },
        z_lectureTime: function (){
            let z_lecturesTimes = 0.0;
            this.z_themes.forEach(theme => {
                if (theme.lecture != ""){
                    z_lecturesTimes += parseFloat(theme.lecture)
                }
            })
            this.times["Лекционные занятия"].input = z_lecturesTimes.toFixed(1)
            return z_lecturesTimes.toFixed(1)
        },
        z_practiceTime: function (){
            let z_practiceTimes = 0.0;
            this.z_themes.forEach(theme => {
                if (theme.practice != ""){
                    z_practiceTimes += parseFloat(theme.practice)
                }
            })
            this.times["Практические занятия"].input = z_practiceTimes.toFixed(1)
            return z_practiceTimes.toFixed(1)
        },
        z_laboratoryTime: function (){
            let z_laboratoryTimes = 0.0;
            this.z_themes.forEach(theme => {
                if (theme.laboratory != ""){
                    z_laboratoryTimes += parseFloat(theme.laboratory)
                }
            })
            this.times["Лабораторные занятия"].input = z_laboratoryTimes.toFixed(1)
            return z_laboratoryTimes.toFixed(1)
        },
        z_ikrTime: function (){
            let z_ikrTimes = 0.0;
            this.z_themes.forEach(theme => {
                if (theme.ikr != ""){
                    z_ikrTimes += parseFloat(theme.ikr)
                }
            })
            this.times["Иная контактная работа"].input = z_ikrTimes.toFixed(1)
            return z_ikrTimes.toFixed(1)
        },
        z_ktoTime: function (){
            let z_ktoTimes = 0.0;
            this.z_themes.forEach(theme => {
                if (theme.kto != ""){
                    z_ktoTimes += parseFloat(theme.kto)
                }
            })
            this.times["Контактные часы на теоретическое обучение"].input = z_ktoTimes.toFixed(1)
            return z_ktoTimes.toFixed(1)
        },
        z_keTime: function (){
            let z_keTimes = 0.0;
            this.z_themes.forEach(theme => {
                if (theme.ke != ""){
                    z_keTimes += parseFloat(theme.ke)
                }
            })
            this.times["Контактные часы на экзамен"].input = z_keTimes.toFixed(1)
            return z_keTimes.toFixed(1)
        },
        z_controlTime: function (){
            let z_controlTimes = 0.0;
            this.z_themes.forEach(theme => {
                if (theme.control != ""){
                    z_controlTimes += parseFloat(theme.control)
                }
            })
            this.times.Экзамен.input = z_controlTimes.toFixed(1)
            return z_controlTimes.toFixed(1)
        },
        z_indepTime: function (){
            let z_indepTimes = 0.0;
            this.z_themes.forEach(theme => {
                if (theme.indep_work != ""){
                    z_indepTimes += parseFloat(theme.indep_work)
                }
            })
            this.times["Самостоятельная работа"].input = z_indepTimes.toFixed(1)
            return z_indepTimes.toFixed(1)
        },
        z_indepWork: function (){
            return this.z_themes.filter(theme => theme.indep_work !== "")
        },
        z_part: function (){
            let z = false
            if ((this.main_info.speciality_code === '13.03.01' || (this.main_info.speciality_code === '13.03.02' && this.main_info.profile === 'Электроэнергетика')) && (this.main_info.discipline !== 'Спортивные игры' && this.main_info.discipline !== 'Общая физическая подготовка' && this.main_info.discipline !== 'Легкая атлетика') || (this.main_info.speciality_code === '21.05.02' || this.main_info.speciality_code === '40.03.01') && (this.main_info.discipline !== 'Python. Анализ данных' && this.main_info.discipline !== 'Компьютерная графика') || (this.main_info.speciality_code === '38.05.01' || this.main_info.speciality_code === '20.03.01') && (this.main_info.discipline !== 'Спортивные игры' && this.main_info.discipline !== 'Общая физическая подготовка' && this.main_info.discipline !== 'Легкая атлетика' && this.main_info.discipline !== 'Python. Анализ данных' && this.main_info.discipline !== 'Компьютерная графика') || this.main_info.speciality_code === '44.03.02'  ||this.main_info.speciality_code === '38.05.02' && this.main_info.edu_form === 'Очная'){
                z = true
            }
            return z
        },
        z_control: function (){
            this.z_times = {
                "Экзамен": {input: 0.0, period: [], used: false},
                "Зачет": {input: 0.0, period: [], used: false},
                "Зачет с оценкой": {input: 0.0,  period: [], used: false},
            }
            this.z_themes.forEach(theme =>{
                if (theme.name.replaceAll(" ","").replace(/(?:\r\n|\r|\n)/g, "").toLowerCase() === "экзамен"){
                    this.z_times.Экзамен.input += (parseFloat(theme.ke) + parseFloat(theme.control))
                    this.z_times.Экзамен.period.push(theme.period)
                    this.z_times.Экзамен.used = true;
                }
                if (theme.name.replaceAll(" ","").replace(/(?:\r\n|\r|\n)/g, "").toLowerCase() === "зачет" || theme.name.replaceAll(" ","").replace(/(?:\r\n|\r|\n)/g, "").toLowerCase() === "зачёт"){
                    this.z_times.Зачет.input += parseFloat(theme.kto)
                    this.z_times.Зачет.period.push(theme.period)
                    this.z_times.Зачет.used = true;
                }
                if (theme.name.replaceAll(" ","").replace(/(?:\r\n|\r|\n)/g, "").toLowerCase() === "зачетсоценкой" || theme.name.replaceAll(" ","").replace(/(?:\r\n|\r|\n)/g, "").toLowerCase() === "зачётсоценкой"){
                    this.z_times["Зачет с оценкой"].input += parseFloat(theme.kto)
                    this.z_times["Зачет с оценкой"].period.push(theme.period)
                    this.z_times["Зачет с оценкой"].used = true;
                }
            })
            this.z_times.Экзамен.input = parseFloat(this.z_times.Экзамен.input).toFixed(1);
            this.z_times.Зачет.input =  parseFloat(this.z_times.Зачет.input).toFixed(1);
            this.z_times["Зачет с оценкой"].input =  parseFloat(this.z_times["Зачет с оценкой"].input).toFixed(1);

            return this.z_times.Экзамен
        },
        spo_control: function (){
            this.spo_times = {
                "Семестровый контроль": {input: 0.0, period: [], used: false},
                "Другие формы контроля": {input: 0.0, period: [], used: false},
                "Курсовой проект": {input: 0.0, period: [], used: false},
                "Курсовая работа": {input: 0.0,  period: [], used: false},
            }
            this.o_themes.forEach(theme =>{
                if (theme.name.replaceAll(" ","").toLowerCase() === "семестровыйконтроль"){
                    this.spo_times["Семестровый контроль"].input += (parseFloat(theme.kto) + parseFloat(theme.control))
                    this.spo_times["Семестровый контроль"].period.push(theme.period)
                    this.spo_times["Семестровый контроль"].used = true;
                }
                if (theme.name.replaceAll(" ","").toLowerCase() === "другиеформыконтроля"){
                    this.spo_times["Другие формы контроля"].input += (parseFloat(theme.ke) + parseFloat(theme.control))
                    this.spo_times["Другие формы контроля"].period.push(theme.period)
                    this.spo_times["Другие формы контроля"].used = true;
                }
                if (theme.name.replaceAll(" ","").toLowerCase() === "курсовойпроект" || theme.name.replaceAll(" ","").toLowerCase() === "курсовоепроектирование"){
                    this.spo_times["Курсовой проект"].input += (parseFloat(theme.ke) + parseFloat(theme.control))
                    this.spo_times["Курсовой проект"].period.push(theme.period)
                    this.spo_times["Курсовой проект"].used = true;
                }
                if (theme.name.replaceAll(" ","").toLowerCase() === "курсоваяработа"){
                    this.spo_times["Курсовая работа"].input += (parseFloat(theme.ke) + parseFloat(theme.control))
                    this.spo_times["Курсовая работа"].period.push(theme.period)
                    this.spo_times["Курсовая работа"].used = true;
                }
            })
            this.spo_times["Семестровый контроль"].input = parseFloat(this.spo_times["Семестровый контроль"].input).toFixed(1);
            this.spo_times["Другие формы контроля"].input = parseFloat(this.spo_times["Другие формы контроля"].input).toFixed(1);
            this.spo_times["Курсовой проект"].input =  parseFloat(this.spo_times["Курсовой проект"].input).toFixed(1);
            this.spo_times["Курсовая работа"].input =  parseFloat(this.spo_times["Курсовая работа"].input).toFixed(1);

            return this.spo_times["Другие формы контроля"]
        },

        errors: function(){
            let er = []
            if (this.main_info.dep_manager !== null && this.main_info.dep_manager.split(' ').length !== 3){
                er.push("ФИО заведующего кафедрой, должно быть написано полностью")
            }
            this.themes.forEach(theme =>{
                if (theme.num === null || theme.num === ""){
                    er.push("У темы обязательно должен быть порядковый номер и она не должна быть пустой")
                }
            })
            if (this.o_lectureTime !== this.times["Лекционные занятия"].need ){
                er.push("Количество введенных часов на Лекционные занятия в РП и в Учебном плане не совпадают")
            }if (this.o_practiceTime !== this.times["Практические занятия"].need ){
                er.push("Количество введенных часов на Практические занятия в РП и в Учебном плане, не совпадают")
            }if (this.o_laboratoryTime !== this.times["Лабораторные занятия"].need ){
                er.push("Количество введенных часов на Лабораторные занятия в РП и в Учебном плане, не совпадают")
            }if (this.o_lessonTime !== this.times["Уроки"].need ){
                er.push("Количество введенных часов на Уроки в РП и в Учебном плане, не совпадают")
            }if (this.o_seminarTime !== this.times["Семинарские занятия"].need ){
                er.push("Количество введенных часов на Семинарские занятия в РП и в Учебном плане, не совпадают")
            }if (this.o_ikrTime !== this.times["Иная контактная работа"].need ){
                er.push("Количество введенных часов на Иная контактная работа в РП и в Учебном плане, не совпадают")
            }if (this.o_ktoTime !== this.times["Контактные часы на теоретическое обучение"].need ){
                er.push("Количество введенных часов на Контактные часы на теоретическое обучение в РП и в Учебном плане, не совпадают")
            }if (this.o_keTime !== this.times["Контактные часы на экзамен"].need ){
                er.push("Количество введенных часов на Контактные часы на экзамен в РП и в Учебном плане, не совпадают")
            }if (this.o_controlTime !== this.times.Экзамен.need ){
                er.push("Количество введенных часов на Экзамен в РП и в Учебном плане, не совпадают")
            }if (this.o_indepTime !== this.times["Самостоятельная работа"].need ){
                er.push("Количество введенных часов на Самостоятельная работа в РП и в Учебном плане, не совпадают")
            }if (this.main_info.load.hour === '0.0'){
                er.push("Учебный план был изменен, данная дисциплина заменена на другую, сохраните дисциплину в качестве щаблона и пересоздайте РПД")
            }
            return er
        }
    },
    methods: {
        getControl() {
            this.main_info.load.hour = 0;
            this.main_info.exam = [];
            this.main_info.credit = [];
            this.main_info.credit_mark = [];
            this.main_info.period = [];
            this.main_info.course = [];
            this.overload.forEach(el => {
                if (el.load === "Экзамен" || el.load.replaceAll(" ","").toLowerCase()  === "экзамен(спо)"){
                    this.main_info.exam.push(this.period[el.period][1]);
                }
                else if (el.load === "Зачет" || el.load.replaceAll(" ","").toLowerCase()  === "зачет(спо)"){
                    this.main_info.credit.push(this.period[el.period][1]);
                }
                else if (el.load === "Зачет с оценкой" || el.load.replaceAll(" ","").toLowerCase()  === "дифференцированныйзачет(спо)"){
                    this.main_info.credit_mark.push(this.period[el.period][1]);
                }
                this.main_info.period.push(this.period[el.period][1]);
                this.main_info.course.push(this.period[el.period][0]);
                this.main_info.load.hour += el.value;
            })
            this.main_info.period = this.main_info.period.filter(this.uniq);
            this.main_info.course = this.main_info.course.filter(this.uniq);
            this.main_info.exam.sort();
            this.main_info.credit.sort();
            this.main_info.credit_mark.sort();
            this.main_info.period.sort();
            this.main_info.course.sort();
            this.main_info.load.hour = parseFloat(this.main_info.load.hour).toFixed(1)
            this.main_info.load.zet = (this.main_info.load.hour / 36).toFixed(2);
        },
        getTimes(){
            this.times = {
                "Лекционные занятия": {input: 0.0, need: 0.0, used: true},
                "Практические занятия": {input: 0.0, need: 0.0, used: true},
                "Лабораторные занятия": {input: 0.0, need: 0.0, used: true},
                "Уроки": {input: 0.0, need: 0.0, used: true},
                "Семинарские занятия": {input: 0.0, need: 0.0, used: true},
                "Иная контактная работа": {input: 0.0, need: 0.0, used: true},
                "Контактные часы на теоретическое обучение": {input: 0.0, need: 0.0, used: true},
                "Экзамен": {input: 0.0, need: 0.0, used: true},
                "Контактные часы на экзамен": {input: 0.0, need: 0.0, used: true},
                "Самостоятельная работа": {input: 0.0, need: 0.0, used: true},
            },
                Object.entries(this.times).forEach(time => {
                    this.overload.forEach(el => {
                        if (time[0].replaceAll(" ","").toLowerCase() === el.load.replaceAll(" ","").toLowerCase()){
                            time[1].used = true;
                            time[1].need += el.value;
                        }
                    })
                    time[1].need = time[1].need.toFixed(1)
                })
            this.overload.forEach(el => {
                if (el.load.replaceAll(" ","").toLowerCase()  === "контактныечасытеоретическогообучения" || el.load.replaceAll(" ","").toLowerCase()  === "контрольтеоретическогообучения"){
                    this.times["Контактные часы на теоретическое обучение"].need = parseFloat(this.times["Контактные часы на теоретическое обучение"].need) + parseFloat(el.value);
                    this.times["Контактные часы на теоретическое обучение"].used = true;
                }
                if (el.load.replaceAll(" ","").toLowerCase()  === "реферат" || el.load.replaceAll(" ","").toLowerCase()  === "самостоятельнаяработа(спо)"){
                    this.times["Самостоятельная работа"].need = parseFloat(this.times["Самостоятельная работа"].need) + parseFloat(el.value);
                    this.times["Самостоятельная работа"].used = true;
                }
                if (el.load.replaceAll(" ","").toLowerCase()  === "лекционныезанятия(спо)"){
                    this.times["Лекционные занятия"].need = parseFloat(this.times["Лекционные занятия"].need) + parseFloat(el.value);
                    this.times["Лекционные занятия"].used = true;
                }
                if (el.load.replaceAll(" ","").toLowerCase()  === "практическиезанятия(спо)" || el.load.replaceAll(" ","").toLowerCase()  === "семинарскиезанятия(спо)"){
                    this.times["Практические занятия"].need = parseFloat(this.times["Практические занятия"].need) + parseFloat(el.value);
                    this.times["Практические занятия"].used = true;
                }
                if (el.load.replaceAll(" ","").toLowerCase()  === "лабораторныезанятия(спо)"){
                    this.times["Лабораторные занятия"].need = parseFloat(this.times["Лабораторные занятия"].need) + parseFloat(el.value);
                    this.times["Лабораторные занятия"].used = true;
                }
                if (el.load.replaceAll(" ","").toLowerCase()  === "часынаконтроль" || el.load.replaceAll(" ","").toLowerCase()  === "экзамен(спо) "){
                    this.times.Экзамен.need = parseFloat(this.times.Экзамен.need) + parseFloat(el.value);
                    this.times.Экзамен.used = true;
                }
                if (el.load.replaceAll(" ","").toLowerCase() === "индивидуальныезанятия" || el.load.replaceAll(" ","").toLowerCase() === "курсовоепроектирование(спо)" || el.load.replaceAll(" ","").toLowerCase() === "курсоваяработа(спо)"){
                    this.times["Иная контактная работа"].need = parseFloat(this.times["Иная контактная работа"].need) + parseFloat(el.value);
                    this.times["Иная контактная работа"].used = true;
                }
                if (el.load.replaceAll(" ","").toLowerCase() === "контрольэкзаменов" || el.load.replaceAll(" ","").toLowerCase()  === "консультация(спо)" || el.load.replaceAll(" ","").toLowerCase()  === "семестровыйконтроль"){
                    this.times["Контактные часы на экзамен"].need = parseFloat(this.times["Контактные часы на экзамен"].need) + parseFloat(el.value);
                    this.times["Контактные часы на экзамен"].used = true;
                }
            })
            this.times["Контактные часы на теоретическое обучение"].need = parseFloat(this.times["Контактные часы на теоретическое обучение"].need).toFixed(1);
            this.times["Иная контактная работа"].need = parseFloat(this.times["Иная контактная работа"].need).toFixed(1);
            this.times["Контактные часы на экзамен"].need = parseFloat(this.times["Контактные часы на экзамен"].need).toFixed(1);
            this.times["Лекционные занятия"].need = parseFloat(this.times["Лекционные занятия"].need).toFixed(1);
            this.times["Практические занятия"].need = parseFloat(this.times["Практические занятия"].need).toFixed(1);
            this.times["Лабораторные занятия"].need = parseFloat(this.times["Лабораторные занятия"].need).toFixed(1);
            this.times["Самостоятельная работа"].need = parseFloat(this.times["Самостоятельная работа"].need).toFixed(1);
            this.times.Экзамен.need = parseFloat(this.times.Экзамен.need).toFixed(1);
        },
        AddUKCompetition(){
            this.rpd_competitions.UK.push({info: {}, text: "", control: ""})
        },
        DelUKCompetition(index){
            this.rpd_competitions.UK.splice(index, 1)
        },
        AddOPKCatCompetition(){
            this.rpd_competitions.OPK_cat.push({info: {}, text: "", control: ""})
        },
        DelOPKCatCompetition(index){
            this.rpd_competitions.OPK_cat.splice(index, 1)
        },
        AddOPKCompetition(){
            this.rpd_competitions.OPK.push({name:"", text: "", control: ""})
        },
        DelOPKCompetition(index){
            this.rpd_competitions.OPK.splice(index, 1)
        },
        AddPKCompetition(){
            this.rpd_competitions.PK.push({name:"", text: "", control: ""})
        },
        DelPKCompetition(index){
            this.rpd_competitions.PK.splice(index, 1)
        },
        AddDPKCompetition(){
            this.rpd_competitions.DPK.push({name:"", text: "", control: ""})
        },
        DelDPKCompetition(index){
            this.rpd_competitions.DPK.splice(index, 1)
        },
    }
}